import { MainMenuType } from "src/util/enums/entityType"

export const GET_LOCATION_TIMEOUT = 1000 // 1 second

export const LANGUAGE_LIST = ["English", "Danish", "Bulgarian", "Russian", "Spanish"]

export const HEALTH_INDICATOR_COLORS = ["#D21F34", "#F08227", "#00943B"]

export const SMALL_SCREEN_WIDTH = 375

export const SFX_CARD_HEIGHT = 144
export const SFX_CARD_CONDENSED_HEIGHT = 104
export const SFX_CARD_ATTACHMENT_HEIGHT = 100

export const SFX_CARD_IMG_WIDTH = "112px"

export const SKELETON_ANIMATION = "fade"

export const DEBOUNCE_TIME_API_CALL = 300000

// NOTE: Maybe not the best approach to use regex. Might be better to just let the user get "entity not found" page
// UUIDs are exactly 36 characters long.
export const UUID_REGEX = "([\\w|-]{36})"

export const DATE_TIME_FULL_MASK = "YYYY-MM-DD HH:mm"
export const DATE_MASK = "YYYY-MM-DD"
// The default date format the QDate accepts
export const DATE_MASK_FORWARD_SLASH_SEPARATOR = "YYYY/MM/DD"
export const TIME_MASK = "HH:mm"

export const STAGNANT_WORK_DAYS = 7
export const STAGNANT_WORK_INTERVAL = 3_600_000 // 1 hour in ms

export const SCANNED_IDENTIFIER_LIFETIME = 900_000 // 15 minutes in ms

export const CACHE_IMAGES = "images"
export const CACHE_AVATARS = "avatars"

export const MANAGER_MAIN_MENU =
  // NB! List order is important as this is how they are going to be shown
  [MainMenuType.WORK_ORDERS, MainMenuType.ITEMS, MainMenuType.ISSUES, MainMenuType.PERFORMED_WORK]

// NB! List order is important as this is how they are going to be shown

export const ENTITY_PAGES = [
  "area",
  "attachment",
  "workspace",
  "layout",
  "work_order",
  "zone",
  "item",
  "model",
  "location",
  "issue",
  "performed_work",
] as const
